import React, { useEffect, useState } from 'react';
import TrackGallery from '../components/tracks/TrackGallery';
import LatestRelease from '../components/sections/LatestRelease';
import Loading from '../components/common/Loading';
import { fetchLatestRelease } from '../services/api';
import './Tracks.css';

const Tracks = () => {
    const [latestRelease, setLatestRelease] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const getLatestRelease = async () => {
            try {
                setError(null);
                const data = await fetchLatestRelease();
                setLatestRelease(data);
            } catch (error) {
                console.error('Error fetching latest release:', error);
                setError('Failed to load track data. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        getLatestRelease();
    }, []);

    const handleRetry = () => {
        setLoading(true);
        setError(null);
        // Trigger useEffect again
        const getLatestRelease = async () => {
            try {
                const data = await fetchLatestRelease();
                setLatestRelease(data);
            } catch (error) {
                console.error('Error fetching latest release:', error);
                setError('Failed to load track data. Please try again.');
            } finally {
                setLoading(false);
            }
        };
        getLatestRelease();
    };

    if (loading) {
        return (
            <div className="tracks-page">
                <div className="tracks-page-loading">
                    <Loading />
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="tracks-page">
                <div className="tracks-page-error">
                    <div className="error-message">{error}</div>
                    <button onClick={handleRetry} className="retry-button">
                        Retry Connection
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="tracks-page">
            <div className="tracks-page-header">
                <h1 className="tracks-page-title">Audio Arsenal</h1>
                <p className="tracks-page-subtitle">Combat-Ready Sound Systems</p>
                
                <div className="tracks-status">
                    <div className="status-indicator">
                        <div className="status-dot active"></div>
                        Audio Systems Online
                    </div>
                    <div className="status-indicator">
                        <div className="status-dot active"></div>
                        Tracks Loaded: {latestRelease ? '1+' : '0'}
                    </div>
                    <div className="status-indicator">
                        <div className="status-dot active"></div>
                        Mech Status: Operational
                    </div>
                </div>
            </div>
            
            <LatestRelease release={latestRelease} />
            <TrackGallery />
        </div>
    );
};

export default Tracks;